import React, { useContext, useEffect, useState, useCallback } from 'react'
import './TrackCandidate.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { UserTypeContext } from '../../AppRoute';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import VisibilityIcon from '@mui/icons-material/Visibility';
// import 'beautiful-react-diagrams/styles.css';
import Cancel from '@mui/icons-material/Cancel';
import Search from '@mui/icons-material/Search';
import DataTable from '../../components/DataTable/DataTable';
import submissionReports from '../../apis/requisitionReports/submissionReport';
import getTrackCandidateInfo from '../../apis/getTrackCandidateInfo/getTrackCandidateInfo';
import {
  NotificationManager,
} from "react-notifications";
import Tooltip from '@mui/material/Tooltip';

function TrackCandidateBody() {
  const location = useLocation();
  const { userType, userIdType, userRecruitmentpartnerId } = useContext(UserTypeContext);
  const [showHistory, setShowHistory] = React.useState(false)
  const [candidateInfo, setCandidateInfo] = useState([]);
  const [candidateInfoLoading, setCandidateInfoLoading] = useState(false)
  const endSelectedDate = new Date();
  const [email, setemail] = useState('')
  
  const history = useNavigate();
  const [candidateProfile, setCandidateProfile] = useState('')

  // DataTable / report states
  const [isSearching, setIsSearching] = useState(true);
  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const [dataResult, setDataResult] = useState([]);

  const searchCandidate = async () => {
    if(email === '') {
      NotificationManager.error('Please enter email to search candidate', 'Error',10000);
      return
    } else {
      setShowHistory(true)
      const response = await getTrackCandidateInfo({
        candidateEmail: email,
        recruitmentPartnerId: userRecruitmentpartnerId,
      });
      const userData = response?.data?.data?.userDetails[0]
      setCandidateInfo(userData)
      setCandidateInfoLoading(response?.data?.data?.userDetails?.length > 0 ? true : false)
      let url = '';
      if (userData?.powerResumeId) {
        url = 'candidate/profile/' + userData?.powerResumeId + '/' + userData.recruitmentOrgId
      }
      else {
        url = 'only-candidate-profile/' + userData?.candidateId
      }
      setCandidateProfile(url)
    }


  }

  // Columns (memoized) - trackCandidateSearch is true for this page
  const columns = [
    {
      accessorKey: "recruiter",
      header: "Recruiter",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "submissionDate",
      header: "Submitted Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { created_at } = row.original;
        if (!created_at) return "N/A";
        const date = new Date(created_at);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "displayDate",
      header: "Status Change Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { displayDate } = row.original;
        if (!displayDate) return "N/A";
        const date = new Date(displayDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "name",
      header: "Candidate Name",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "gender",
      header: "Gender",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "email",
      header: "Email",
      width: "300px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "client",
      header: "Client",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "clientId",
      header: "Client ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "status",
      header: "Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "reqreferenceId",
      header: "Reference ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "currentStatus",
      header: "Current Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "city",
      header: "City",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "state",
      header: "State",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "country",
      header: "Country",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "offerDate",
      header: "Offer Released Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { offerDate } = row.original;
        if (!offerDate) return "N/A";
        const date = new Date(offerDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "interviewDate",
      header: "Interview Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { interviewDate } = row.original;
        if (!interviewDate) return "N/A";
        const date = new Date(interviewDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "joiningDate",
      header: "Joining Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { joiningDate } = row.original;
        if (!joiningDate) return "N/A";
        const date = new Date(joiningDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "selectedDate",
      header: "Selected Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { selectedDate } = row.original;
        if (!selectedDate) return "N/A";
        const date = new Date(selectedDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { startDate } = row.original;
        if (!startDate) return "N/A";
        const date = new Date(startDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "salary",
      header: "Salary",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "hourlyMargin",
      header: "Hourly Margin",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "placementType",
      header: "Placement Type",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "primarySkill",
      header: "Primary Skill",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "phone",
      header: "Phone",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "updated_at",
      header: "Activity Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "dropOutNotes",
      header: "Drop Out Notes",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "recruiterLeader",
      header: "Person of Contact",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "source",
      header: "Source",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "resumeStatus",
      header: "External Source",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    }
  ]

  const formatDateOnly = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const performSearch = useCallback(async (candidateEmail, pageNumberArg, takeNumberOfResultArg) => {
    setIsSearching(true);
    setDataResult([]);

    const payload = {
      orgId: userRecruitmentpartnerId,
      page: pageNumberArg,
      size: takeNumberOfResultArg,
      formattedDatestart: formatDateOnly('2024-01-01T12:21:53.000Z'),
      formattedDateend: formatDateOnly(endSelectedDate?.toISOString()),
      isExport: false,
      userId: userIdType,
      role: userType,
      additionalFilter: {
        placementType: [],
        clientName: [],
        divisionId: [],
        interview_date: "",
        joining_date: "",
        start_date: "",
        selected_date: "",
        offer_date: "",
        teamId: []
      },
      page_initiator: "",
    };

    if (candidateEmail) payload.candidateEmail = candidateEmail;

    try {
      const search = await submissionReports(payload);
      if (!search?.data || search.data.length === 0) {
        setDataResult([]);
        setTotalResult(0);
      } else {
        setDataResult(search.data);
        if (search.totalCount && search.totalCount[0] && search.totalCount[0].total) {
          setTotalResult(search.totalCount[0].total);
        }
      }
    } catch (err) {
      console.error('Error fetching candidate history:', err);
      NotificationManager.error('Error fetching data', 'Error', 2500);
      setDataResult([]);
      setTotalResult(0);
    } finally {
      setIsSearching(false);
    }
  }, [userRecruitmentpartnerId, userIdType, userType, formatDateOnly]);

  // Trigger search when showing history or when navigated with candidate email in state
  useEffect(() => {
    let activeEmail = null;
    if (showHistory) activeEmail = email;
    if (location?.state?.checkCandidateHistory) activeEmail = location?.state?.candidateEmail || activeEmail;

    if (!activeEmail) return;

    const timeout = setTimeout(() => {
      performSearch(activeEmail, pageNumber, takeNumberOfResult);
    }, 500);

    return () => clearTimeout(timeout);
  }, [showHistory, location?.state?.checkCandidateHistory, location?.state?.candidateEmail, email, pageNumber, takeNumberOfResult]);

  const handleEmailChange = (e) => {
    setemail(e.target.value.trim());
    setShowHistory(false)
    setCandidateInfo([])
    setCandidateInfoLoading(false)
    setCandidateProfile('')
    setShowHistory(false)
  }



  const clearEmailField = () => {
    setemail('')
    setShowHistory(false)
    setCandidateInfo([])
    setCandidateInfoLoading(false)
    setCandidateProfile('')
    setShowHistory(false)
  }



  const goToMyTallent = () => {
    history('/')
  };

  return (
    <div className='trackCandidateContainer'>
      <div className="communityHeader_candidate_history">
        <div className="goBackButton_candidate_history" onClick={(e) => goToMyTallent(e)}>
          <Tooltip title="Go Back to Dashboard" placement="bottom">
            <ArrowBackIcon className="trackCandidate_backIcon" />
          </Tooltip>
          {/* <span>&nbsp;Go Back to Dashboard</span> */}
        </div>
        <div className="communityTitle_candidate_history">Candidate History</div>

      </div>

      {
        location?.state?.checkCandidateHistory ? <></> : <div className='trackCand_UpperCard'>
          <div className='trackCand_searchFieldsContainer'>
            <div>
              <div className='trackCandidate_searchHeading'>Candidate Email:*</div>
              <TextField
                placeholder="Candidate Email"
                className="trackCandidate_textField"
                variant='standard'
                fullWidth
                value={email}
                onChange={(e) => handleEmailChange(e)}
                //add cross 
                InputProps={{
                  endAdornment: (
                    <>
                      {
                        email.length > 0 ?
                          <Cancel
                            className="trackCandidate_clearIcon"
                            onClick={clearEmailField}
                          />
                          : ''
                      }
                    </>
                  ),
                }}
              />
            </div>
            {candidateInfoLoading ?
              <div className="trackCandidate_candidateNameRow">
                <div className='trackCandidate_searchHeading'>Candidate Name: </div>
                <div className='trackCandidate_searchHeading trackCandidate_candidateNameValue'>  {candidateInfo?.name}</div>

              </div>
              : <></>}


          </div>

          <div className='trackCand_SearchBtn'>

            <Button
              variant="contained"
              startIcon={<Search />}
              className="trackCandidate_btn trackCandidate_btn_search"
              onClick={searchCandidate}
            >
              Search Candidate
            </Button>




            <Button
              variant="contained"
              startIcon={<VisibilityIcon />}
              className="trackCandidate_btn trackCandidate_btn_view"
              onClick={() => window.open(candidateProfile, '_blank', 'noreferrer noopener')}
              color='primary'
              disabled={candidateInfo?.length === 0 || candidateInfo === undefined}
            >
              View Candidate Profile
            </Button>

          </div>

        </div>
      }


      {/* ---------- Make sure to remove the hardcoded startdate and do the necessary changes from the backend api --------*/}
      {
        showHistory ? (
          <DataTable
            data={dataResult}
            columns={columns}
            isLoading={isSearching}
            totalRecords={totalResult}
            currentPage={pageNumber}
            pageSize={takeNumberOfResult}
            onPageChange={(newPage, newPageSize) => {
              setPageNumber(newPage);
              if (newPageSize && newPageSize !== takeNumberOfResult) setTakeNumberOfResult(newPageSize);
            }}
            onPageSizeChange={(newSize) => { setTakeNumberOfResult(newSize); setPageNumber(1); }}
            onFilterChange={() => {}}
            enableFiltering={false}
            enablePagination={true}
            enableSorting={false}
            pageSizeOptions={[10, 20, 50, 100]}
            isServerSide={true}
            className="kendo_reports"
            noDataText="No results found !"
          />
        ) : ''
      }

      {
        location?.state?.checkCandidateHistory ? (
          <DataTable
            data={dataResult}
            columns={columns}
            isLoading={isSearching}
            totalRecords={totalResult}
            currentPage={pageNumber}
            pageSize={takeNumberOfResult}
            onPageChange={(newPage, newPageSize) => {
              setPageNumber(newPage);
              if (newPageSize && newPageSize !== takeNumberOfResult) setTakeNumberOfResult(newPageSize);
            }}
            onPageSizeChange={(newSize) => { setTakeNumberOfResult(newSize); setPageNumber(1); }}
            onFilterChange={() => {}}
            enableFiltering={false}
            enablePagination={true}
            enableSorting={false}
            pageSizeOptions={[10, 20, 50, 100]}
            isServerSide={true}
            className="kendo_reports"
            noDataText="No results found !"
          />
        ) : ''
      }
      {
        showHistory || location?.state?.checkCandidateHistory ? <></> :
          <div className="trackCandidate_spacer">
          </div>
      }
    </div>
  )
}

export default TrackCandidateBody



